import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Sindhura from '../../../../Assets/Images/Sindhura.png';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Alphonso from '../../../../Assets/Images/Alphonso.png';
import Strawberry from '../../../../Assets/Images/Strawberry.png';
import BlackGrapes from '../../../../Assets/Images/BlackGrapes.png';
import Carousel from "react-multi-carousel";
import { title } from 'process';




function TextTestimonials(props) {
 

    return (
        <div className='row'>
            <div className='col'>

                <Card style={{  height:'410px' }} className='farmerTestimonials mx-auto'>
                    <Card.Body>

                        <Card.Text className='farmerTestimonialsMessage' >
                           <span className='farmerText '>{ props.item.Message}</span>
                        </Card.Text>
                       
                        <Card.Text className='fw-bold farmerTestimonialsName'> 
                             { props.item.Name }</Card.Text>

                    </Card.Body>
                </Card>

            </div>
        </div>
        
    )
}

export default TextTestimonials